import ContentViewer from './ContentViewer';
import ContentPrint from './ContentPrint';
import ContentPreview from './ContentPreview';
import ContentIP from './ContentIP';
import ContentEditor from './ContentEditor';
import DraftPreview from './DraftPreview';
import DraftPreviewActivity from './ContentActivity/DraftPreviewActivity';
import LatestPreviewActivity from './ContentActivity/LatestPreviewActivity';
import MajorMinorPreviewActivity from './ContentActivity/MajorMinorPreviewActivity';
import ContentViewerLayout from './_layout/index.vue';
import SpeakerNotes from './SpeakerNotes';
import AudienceNotes from './AudienceNotes';

export default [
	{
		name: 'Content Draft Print',
		path: '/content/:library_id/:id/draft/print',
		props: true,
		component: ContentPrint
	},
	{
		name: 'Content Print',
		path: '/content/:library_id/:id/:major_revision/:minor_revision/print',
		props: true,
		component: ContentPrint
	},
	{
		name: 'Content Preview',
		path: '/content/:library_id/:id/:major_revision/:minor_revision/preview',
		props: true,
		component: ContentPreview
	},
	{
		name: 'Content Interactive Presentation App',
		path: '/content/:library_id/:id/:major_revision/:minor_revision/ip',
		props: true,
		component: ContentIP
	},
	{
		name: 'Speaker Notes',
		path: '/content/:library_id/:id/speaker-notes/:view?',
		props: true,
		component: SpeakerNotes
	},
	{
		name: 'Audience Notes',
		path: '/content/:library_id/:id/audience-notes/:view?',
		props: true,
		component: AudienceNotes
	},
	{
		path: '/content/:library_id/:id',
		component: ContentViewerLayout,
		children: [
			// Rutas específicas primero
			{
				name: 'Edit Draft',
				path: 'draft',
				component: ContentEditor,
				props: true
			},
			{
				name: 'Preview Draft',
				path: 'draft/preview',
				component: DraftPreview,
				props: true
			},
			{
				name: 'Preview Activity',
				path: 'draft/preview-activity',
				component: DraftPreviewActivity,
				props: true
			},
			{
				name: 'Preview Approved Activity',
				path: 'latest/preview-activity/:mode?',
				component: LatestPreviewActivity,
				props: route => ({ ...route.params })
			},
			{
				name: 'Content Viewer Latest',
				path: 'latest/:mode?',
				component: ContentViewer,
				props: route => ({ ...route.params })
			},
			{
				name: 'Content Viewer Activity Exact Revision',
				path: ':major_revision/:minor_revision/preview-activity/:mode?',
				component: MajorMinorPreviewActivity,
				props: route => ({ ...route.params })
			},
			{
				name: 'Content Viewer Exact Revision',
				path: ':major_revision/:minor_revision/:mode?',
				component: ContentViewer,
				props: route => ({ ...route.params })
			},
			{
				name: 'Content Viewer',
				path: '',
				redirect: 'latest'
			}
		]
	}
];
